import { render, staticRenderFns } from "./StaffPhotoView.vue?vue&type=template&id=1c555548&scoped=true&"
import script from "./StaffPhotoView.vue?vue&type=script&lang=js&"
export * from "./StaffPhotoView.vue?vue&type=script&lang=js&"
import style0 from "./StaffPhotoView.vue?vue&type=style&index=0&id=1c555548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c555548",
  null
  
)

export default component.exports